import { useState } from "react";
import { permissionsSelector } from "../modules/Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";

const CheckBoxHookForm_2 = ({
  name = "text-name",
  type = "checkbox",
  className,
  label,
  register,
  validation,
  hasPermission,
  disabled = false,
}) => {
  const [focus, setFocus] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div className="space-y-1 w-full text-xs">
      <div className="grid grid-cols-1 md:grid-cols-3 content-center items-center w-full gap-2 py-1">
        {label && (
          <label
            htmlFor={name}
            className="flex  text-left expandedLabel fontExpand"
          >
            {label}
          </label>
        )}
        <input
          type="checkbox"
          name={name}
          className={`${className} w-4 h-4 border-gray-50 cursor-pointer hover:cursor-pointer`}
          onFocus={() => {
            setFocus(true);
          }}
          {...register(name, validation)}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
export default CheckBoxHookForm_2;
